module.exports = __webpack_public_path__ + "img/bg-tit.aeba0c6a.png";